// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"f34f8a87","460":"2380dff7","553":"2380dff7"}[chunkId] + ".chunk.css";
};